import { Stack } from "@mui/material";
import { type ReactNode } from "react";
import { StickyTopActions, type TopAction } from "./sticky-top-actions";

interface Props {
  children: ReactNode;
  topActionBar?: {
    title?: string;
    actions: TopAction[];
  };
  maxWidth?: "full" | "xs" | "sm" | "md" | "lg" | "xl";
}

export const ItemFormLayout = ({
  topActionBar,
  children,
  maxWidth = "lg",
}: Props) => {
  return (
    <Stack
      sx={(theme) => ({
        maxWidth:
          maxWidth === "full" ? "100%" : theme.breakpoints.values[maxWidth],
        mb: "120px",
      })}
    >
      {topActionBar && <StickyTopActions {...topActionBar} />}
      {children}
    </Stack>
  );
};
